<template lang="pug">
  div(v-if="loading")
    .geofenceHeader.white(style="height:120px")
      div
        div.primary.py-3.px-4.white--text.font-weight-bold.subtitle-2() GEOFENCING
        .px-4
          v-text-field.mr-3(v-model='search', label='Search Geofences', persistent-hint, required, :append-icon="'search'" )

    .geofenceList(:style="{'max-height':`${height-200}px`}")
      div(v-for="(item,index) in items" :key="index" @click="selectGeofence(item)" :class="isSelected(item)?'selectedStyle':'geofenceItem'")
        .d-flex.align-center
          div.mx-2()
          div.fill-width
            div.mt-2()
              .d-flex()
                .mr-2
                  template(v-if="isCircle(item)")
                    img(src="@/assets/icons/place.svg")
                  template(v-else)
                    img(src="@/assets/icons/polygon.svg")
                v-list-item-title(v-text="item.name" :class="isSelected(item)?'primary--text':'black-text'")
              v-list-item-subtitle.grey--text(v-text="item.description")
            div.mb-3.mt-2()
              div()
                v-icon.mr-2(small) person
                v-chip.mr-2(x-small v-for="(contact_id,cIndex) in getContactChips(item.contacts_id)" :key="cIndex" v-text="getContactFromID(contact_id)")
                span.caption(v-if="item.contacts_id.length > 3") + {{item.contacts_id.length-3}} more
              div()
                v-icon.mr-2(small) local_shipping
                v-chip.mr-2(x-small v-for="(vehicle_id,vIndex) in getVehicleChips(item.vehicles_id)" :key="vIndex" v-text="getVehicleFromID(vehicle_id)")
                span.caption(v-if="item.vehicles_id.length > 3") + {{item.vehicles_id.length-3}} more
          .d-flex()
            .d-flex.flex-column.fill-height.justify-space-between()
              .logBtn.grey.lighten-2(@click="saveItemState(item,'entry',!item.entry)")
                v-icon(:size="16" :color="item.entry?'grey darken-2':'white'") login
              .logBtn2.grey.lighten-2()
                v-icon(:size="15" :color="item.email?'grey ':'grey lighten-2'") email
            .d-flex.flex-column.fill-height.justify-space-between.mr-2()
              .logBtn.grey.lighten-2(@click="saveItemState(item,'exit',!item.exit)")
                v-icon(:size="16" :color="item.exit?'grey darken-2':'white'") logout
              .logBtn2.grey.lighten-2()
                v-icon(:size="15" :color="item.sms?'grey':'grey lighten-2'") sms
          .mx-2.geoMenuItemselectGeofence
            more-drop-down-menu(:items='menuItems', @onClick='onClick', :theObject='item')

    div()
      vehicle-auto-complete.grey.lighten-3.px-4(v-model='vehicleID' label="Focus Vehicle" placeholder="Vehicle to View"  )
</template>

<script>
import MoreDropDownMenu from "@/modules/global/components/lists/MoreDropDownMenu";
import { polygon } from "@turf/helpers";
import centroid from "@turf/centroid";
const turf = { centroid, polygon };
import VehicleAutoComplete from "@/modules/global/components/forms/VehicleAutoComplete";

export default {
  props: ["height"],
  components: {
    MoreDropDownMenu,
    VehicleAutoComplete
  },
  data: () => ({
    loading: false,
    selected: [],
    menuItems: [
      {title: "Edit", icon: "edit", action: "edit"},
      {title: "Delete", icon: "delete", action: "delete"}
    ],

    search: null,
    theVehicleId: null,

  }),

  mounted() {


      this.loading = true;


  },

  computed: {
    vehicleID: {
      get: function(){
        return this.theVehicleId;
      },
      set: function(value){

        this.$store.commit("tracks/setCurrentIndexByVehicleID",value)
        let theIndex = this.$store.state.tracks.currentIndex
        if(theIndex > -1){
          this.theVehicleId = value;
          let theItem = this.$store.getters["tracks/getCurrentTrack"]
          console.log(theItem.avl_record.location)
          this.$store.geoMap.flyTo({
            center: [theItem.avl_record.location.lon, theItem.avl_record.location.lat],
            essential: true
          })
        }

      }
    },
    items: function () {
      return this.$store.getters["geofence/getGeofenceDataBySearch"](this.search)
    },

    currentGeofence: function () {
      return this.$store.getters["geofence/getCurrentGeofence"]
    },

    createFlag: function () {
      return this.$store.state.geofence.createFlag
    },

    updateFlag: function () {
      return this.$store.state.geofence.updateFlag
    },

    currentIndex: function () {
      return this.$store.state.geofence.currentIndex
    }

  },
  methods: {

    getBgStyle: function (item) {
      let selectedStyle = {'background-color': '#E8E8E8'}
      let normalStyle = {'background-color': '#FFFFFF'}

      return this.isSelected(item) ? selectedStyle : normalStyle;
    },

    isSelected: function (item) {

      // if no element is selected return false
      if (typeof this.$store.geoDraw !== "undefined") {
        // if (this.$store.geoDraw.getSelectedIds().length == 0) {
        //   return false;
        // }
      }
      return !this.updateFlag && !this.createFlag && this.currentGeofence.id == item.id
    },
    isCircle: function (item) {

      return item.geometry != null && item.geometry.type === "Point"
    },

    getContactChips: function (theArray) {
      if (theArray == null || theArray.length == 0) {
        return ["All Contacts"]
      }
      if (theArray.length > 3) {
        return theArray.slice(0, 3)
      } else {
        return theArray
      }
    },

    getContactFromID: function(contact_id) {
      if(contact_id == "All Contacts"){
        return "All Contacts"
      }
      var theContact = this.$store.getters["contacts/getContactByID"](contact_id)
      if (theContact !== undefined && theContact != null) {
        return theContact.full_name
      }else {
        return "unknown"
      }
    },

    getVehicleChips: function (theArray) {
      if (theArray == null || theArray.length == 0) {
        return ["All Vehicles"]
      }
      if (theArray.length > 3) {
        return theArray.slice(0, 3)
      } else {
        return theArray
      }
    },

    getVehicleFromID: function(vehicle_id) {
      console.log(vehicle_id)
      if(vehicle_id == "All Vehicles"){
        return "All Vehicles"
      }



      var theVehicle = this.$store.getters["vehicles/getVehicleByID"](vehicle_id)
      if (theVehicle != undefined) {
        return theVehicle.name
      }else {
        return "unknown"
      }
    },



    onClick: function (value) {
      // console.log(value.theObject);
      switch (value.action) {
        case "edit":

          this.$store.commit("geofence/setCurrentIndexByID", value.theObject.id);
          this.$store.commit("geofence/showDialog", true)
            this.$store.commit("geofence/incrementGeofenceTableKey")
          break;
        case "delete":
          console.log(value)
          confirm(
              "Are you sure you want to delete the Geofence: " + value.theObject.name
          ) && this.$store.dispatch("geofence/deleteGeofence", value.theObject.id).then(() => {
            this.$store.geoDraw.delete(value.theObject.object.id)
            this.$store.commit("geofence/incrementGeofenceTableKey")
          });
          break;
      }
    },

    toggleVisibility: function (item) {
      item.visible = !item.visible;
    },

    saveItemState: function(item,property,data){
      this.$store.commit("geofence/saveItemState",{item:item,property:property,data:data})
    },


    selectGeofence: function (item) {


      // current element has been updated save, save before editing
      if (this.$store.state.geofence.updateFlag) {
        this.$store.dispatch("geofence/saveGeofence").then(() => {
          console.log("Hapa iko maneno")
          console.log(item.name)
          // this.$store.commit("geofence/setCurrentIndexByID", item.id)
          // this.$store.geoDraw.changeMode(this.$store.geoDraw.modes.DIRECT_SELECT, {featureId: item.object.id})
        })
      } else {
        this.$store.commit("geofence/setCurrentIndexByID", item.id)
        this.$store.geoDraw.changeMode(this.$store.geoDraw.modes.DIRECT_SELECT, {featureId: item.object.id})
        console.log(item.geometry)

        switch (item.geometry.type) {
          case "Point":
            this.$store.geoMap.flyTo({
              center: [item.geometry.coordinates[0], item.geometry.coordinates[1]],
              essential: true
            })
            break;
          case "Polygon":
            console.log(item.geometry)
            var polygon = turf.polygon(item.geometry.coordinates);

            var centroid = turf.centroid(polygon)
            this.$store.geoMap.flyTo({
              center: [centroid.geometry.coordinates[0], centroid.geometry.coordinates[1]],
              essential: true
            })

        }


      }

    }
  }
}
</script>

<style lang="stylus" scoped>
.geofenceHeader {
  box-shadow inset 0px -12px 8px -6px #CCCCCC;
}

.fenceIcon {
  margin 10px 10px;
  border 1px solid #666666;
  border-radius 5px;
  padding 6px 10px;

}

.geofenceList {
  overflow-y auto
  overflow-x hidden
}

.geofenceItem {
  border-bottom 1px solid #CCC
  background-color #FFFFFF
}

.geofenceItem:hover {
  background-color #f6f6f6
  cursor pointer
}

.selectedStyle {
  border-bottom 1px solid #CCC
  background-color #ececec
}

.selectedStyle:hover {
  cursor pointer
}

.logBtn {
  border-radius 3px
  padding 2px 2px
  margin 2px 2px
}

.logBtn:hover {
  cursor pointer
}

.logBtn2 {
  border-radius 3px
  padding 2px 2px
  margin 2px 2px
}

</style>